import { Box, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import useAlert from '../hooks/useAlert'

import SettingsFooter from '../settings/shared/SettingsFooter'
import { authedAxios } from '../utils'
import useCurrentIdentity from '../hooks/useCurrentIdentity'

const PasswordChange = () => {
  const [currentPassword, setCurrentPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirmed, setNewPasswordConfirmed] = useState('')

  const [submitting, setSubmitting] = useState(false)

  const { createAlert, createGenericErrorAlert } = useAlert()

  const { currentIdentity, setCurrentIdentity } = useCurrentIdentity()

  const onSuccess = () => {
    reset()
    createAlert({
      severity: 'success',
      message: 'Successfully updated password',
    })
  }

  const onFailure = () => createGenericErrorAlert()

  const reset = () => {
    setCurrentPassword('')
    setNewPassword('')
    setNewPasswordConfirmed('')
  }

  const onSave = () => {
    setSubmitting(true)
    return authedAxios
      .put(`/api/identity/${currentIdentity.id}/password`, {
        currentPassword,
        newPassword,
      })

      .then((res) => {
        if (res.data.success) return onSuccess()

        return createAlert({
          severity: 'error',
          message: 'Incorrect Password',
        })
      })
      .catch(onFailure)
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '750px', maxWidth: '80%' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', mb: 2 }}>
          <TextField
            type='password'
            sx={{ minWidth: '300px', mb: 4 }}
            margin='dense'
            label='Current Password'
            onChange={(e) => setCurrentPassword(e.target.value)}
            value={currentPassword}
          />
          <TextField
            type='password'
            sx={{ minWidth: '300px', mb: 2 }}
            margin='dense'
            label='New Password'
            onChange={(e) => setNewPassword(e.target.value)}
            value={newPassword}
          />
          <TextField
            type='password'
            sx={{ minWidth: '300px', mb: 2 }}
            margin='dense'
            label='Confirm Password'
            onChange={(e) => setNewPasswordConfirmed(e.target.value)}
            value={newPasswordConfirmed}
          />
        </Box>

        {newPassword &&
          newPasswordConfirmed &&
          newPasswordConfirmed !== newPassword && (
            <Typography color={'error'}>New passwords do not match</Typography>
          )}

        <SettingsFooter
          saveButton={{
            onClick: onSave,
            disabled:
              !newPassword ||
              !newPasswordConfirmed ||
              !currentPassword ||
              submitting ||
              newPassword !== newPasswordConfirmed,
          }}
        ></SettingsFooter>
      </Box>
    </Box>
  )
}

export default PasswordChange
